export default __webpack_public_path__ + "static/media/image-xx99-mark-one.cbc118b5.jpg";